<script>
import { mapActions } from 'vuex'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { ScatterChart } from 'echarts/charts'

import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
} from 'echarts/components'
import MChart, { THEME_KEY } from 'vue-echarts'

use([
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
  CanvasRenderer,
  ScatterChart,
])
export default {
  components: {
    MChart,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      optionSeriesRoundTemplate: {
        symbolSize: 8,
        data: null, // round2,
        type: 'scatter',
      },
      options: {
        grid: {
          top: 20,
          bottom: 100,
        },

        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          data: null, // xAxisData,
          silent: false,
          axisLine: {
            onZero: true,
          },
          splitLine: {
            show: false,
          },
          splitArea: {
            show: true,
          },
          axisLabel: {
            interval: 0,
            rotate: 45,
          },
        },
        yAxis: {},
        series: [
          {
            symbolSize: 8,
            data: null, // round1,
            type: 'scatter',
          },
          {
            symbolSize: 8,
            data: null, // round2,
            type: 'scatter',
          },
        ],
      },
    }
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  async created() {
    this.getPlayerStatData({ id: this.playerId })
      .then((response) => {
        if (typeof response !== 'undefined') {
          this.setGraphData(response)

          this.isLoading = false
          this.$emit('loaded', true)
        }
      })
      .catch((error) => {
        console.error(error, 'Opponent Ranking Performance Data fetch failed')
      })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    setGraphData(data) {
      if (
        typeof data.timeline !== 'undefined' &&
        Array.isArray(data.timeline)
      ) {
        var xAxisData = []
        const rounds = []

        const groups = data.opponent_name.reduce(function(obj, item) {
          obj[item.team] = obj[item.team] || []
          obj[item.team].push(item.value)
          return obj
        }, {})

        // console.log('groups >> ', groups)

        const myArray = Object.keys(groups).map(function(key) {
          return {
            team: key,
            value: groups[key],
          }
        })

        // console.log('array >>', myArray)
        const maxGamesAgainstOneTeam = myArray.reduce(
          (max, current) =>
            current.value.length > max ? current.value.length : max,
          0
        )
        // console.log(
        //   'maxGamesAgainsOneTeam >> ',
        //   maxGamesAgainstOneTeam
        // )

        myArray.forEach((value) => {
          xAxisData.push(value.team)
          for (let i = 0; i < maxGamesAgainstOneTeam; i++) {
            if (typeof rounds[i] === 'undefined') {
              rounds[i] = []
            }
            if (
              typeof value.value[i] !== 'undefined' &&
              value.value[i] !== null
            ) {
              rounds[i].push(value.value[i].toFixed(1))
            } else {
              rounds[i].push('-')
            }
          }
        })

        this.options.xAxis.data = xAxisData

        rounds.forEach((round, i) => {
          if (typeof this.options.series[i] === 'undefined') {
            this.options.series[i] = Object.assign(
              {},
              this.optionSeriesRoundTemplate
            )
          }
          this.options.series[i].data = round
        })
      }
    },
    onResize() {
      if (typeof this.$refs.chart !== 'undefined') this.$refs.chart.resize()
    },
  },
}
</script>

<template>
  <v-responsive
    v-if="playerId !== null && playerId"
    v-resize="onResize"
    aspect-ratio="4/3"
    :class="$style.responsive"
  >
    <MChart
      v-if="!isLoading"
      ref="chart"
      :class="$style.chart"
      :option="options"
    />
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

.chart {
  margin: 0 auto;
}

.responsive {
  min-height: 15rem;
  overflow: visible;
}
</style>
